import styled from 'styled-components/macro'

import { mq } from 'styles/mq'
import { Title as TitleBase } from '../../styled'
import { Thread } from 'styles/misc'

export const Title = styled(TitleBase).attrs({ 'data-thread': '' })`
  width: auto;

  ${mq.smallOnly} {
    &::before {
      ${Thread}
      bottom: 0;
      width: 100%;
      aspect-ratio: 2093 / 970;
      transform: translateY(15%);
      mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2092.07 500.37'%3E%3Cpath fill='none' stroke='%23000' stroke-miterlimit='10' d='m.25,44.2C35.28,23.98,71.94,3.26,112.31.7s85.36,19.11,95.5,58.26c5.94,22.93-.68,47.93,6.48,70.51,11.94,37.6,55.49,53.48,93.7,63.29,140.27,36,283.83,59.21,428.3,69.25,94.22,6.54,188.78,7.49,282.89,15.4,18.93,1.59,52.86,2.37,63.15,19.15,11.1,18.11-19.69,55.79-36.66,49.79-17-6.01-8.19-21.41-.56-25.21,48.96-24.42,203.69-19.44,299.57,17.67,95.88,37.11,184.05,92.69,281.31,126,150.25,51.45,319.21,46.07,465.88-14.83' stroke-width='1.5px' vector-effect='non-scaling-stroke' /%3E%3C/svg%3E")
        25% 0 / auto 100% no-repeat !important;
    }
  }
`

export const ThreadWrapper = styled.div`
  ${mq.medium} {
    &::before {
      ${Thread}
      left: 0;
      transform: translate(0, -60%);
      width: 100%;
      aspect-ratio: 2093 / 570;
      mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2092.07 500.37'%3E%3Cpath fill='none' stroke='%23000' stroke-miterlimit='10' d='m.25,44.2C35.28,23.98,71.94,3.26,112.31.7s85.36,19.11,95.5,58.26c5.94,22.93-.68,47.93,6.48,70.51,11.94,37.6,55.49,53.48,93.7,63.29,140.27,36,283.83,59.21,428.3,69.25,94.22,6.54,188.78,7.49,282.89,15.4,18.93,1.59,52.86,2.37,63.15,19.15,11.1,18.11-19.69,55.79-36.66,49.79-17-6.01-8.19-21.41-.56-25.21,48.96-24.42,203.69-19.44,299.57,17.67,95.88,37.11,184.05,92.69,281.31,126,150.25,51.45,319.21,46.07,465.88-14.83' stroke-width='1.5px' vector-effect='non-scaling-stroke' /%3E%3C/svg%3E")
        100% 0 / auto 98% no-repeat !important;
      z-index: 0;
    }
  }
`
